unit SummaryReportSelectorForm;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WebForm.Core, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.Controls, WEBLib.ExtCtrls, WEBLib.DBCtrls, JS,
  WEBLib.Actions;

type
  TSummaryReportSelector = class(TCoreWebForm)
    FromDatePicker: TDateTimePicker;
    ToDatePicker: TDateTimePicker;
    OKButton: TButton;
    CancelButton: TButton;
    AllCheckbox: TCheckBox;
    AllCheckboxLabel: TLabel;
    SummaryReportSelector: TLookupComboBox;
    DateFieldSelector: TLookupComboBox;
    procedure FromDatePickerChange(Sender: TObject);
    procedure ToDatePickerChange(Sender: TObject);
    procedure WebformCreate(Sender: TObject);
    procedure AllCheckboxClick(Sender: TObject);
    procedure OKButtonClick(Sender: TObject);
    procedure SummaryReportSelectorChange(Sender: TObject);
  private
    FIsRunning: Boolean;
    FLastSelected: string;
    function GetFromDate: TDate;
    function GetToDate: TDate;
    procedure SetAllModifier(const Value: string);
    procedure AddReportTypes;
    procedure AddDateFields;
    [async]
    procedure DownloadSummaryReport; async;
  public
    procedure ShowHideAllSelector(ShouldShow: Boolean);
    property FromDate: TDate read GetFromDate;
    property ToDate: TDate read GetToDate;
    property AllModifier: string write SetAllModifier;
  protected procedure LoadDFMValues; override; end;

  var
  SummaryReportSelector: TSummaryReportSelector;

implementation

uses Essentials.Web.Shared, Reports.Summary.Utils,
SMX.Web.Utils, DateUtils, Reports.Shared;

{$R *.dfm}

procedure TSummaryReportSelector.AddDateFields;
var
  df: string;
  i, lDefaultSelect: Integer;
begin
  DateFieldSelector.LookupValues.Clear;
  lDefaultSelect := 0;

  if SummaryReportSelector.Value = CLAIM_ID then
  begin
    for i := 0 to Length(CLAIM_DATE_FIELDS) - 1 do
    begin
      df := CLAIM_DATE_FIELDS[i];
      DateFieldSelector.LookupValues.AddPair(df, TReportUtils.SQLToPascalCase(df, True));

      if df = SUBMISSION_DATE then
        lDefaultSelect := i;
    end;
  end
  else
  begin
    for i := 0 to Length(SUMMARY_DATE_FIELDS) - 1 do
    begin
      df := SUMMARY_DATE_FIELDS[i];
      DateFieldSelector.LookupValues.AddPair(df, TReportUtils.SQLToPascalCase(df, True));

      if df = BANKING_DATE then
        lDefaultSelect := i;
    end;
  end;

  DateFieldSelector.ItemIndex := lDefaultSelect;
end;

procedure TSummaryReportSelector.AddReportTypes;
  function GetCustomName(aFieldName: string) :string;
  begin
    Result := EssentialsManager.CustomNamesManager.EntityFieldName('TDonation', aFieldName);
    if Result = '' then
      Result := TUtils.SplitOnCaps(aFieldName);
  end;
var
  customName :string;
begin{AddReportTypes}
  SummaryReportSelector.Clear;

  SummaryReportSelector.LookupValues.AddPair('ANALYSIS_CODE_1', GetCustomName('AnalysisCode1'));
  SummaryReportSelector.LookupValues.AddPair('ANALYSIS_CODE_2', GetCustomName('AnalysisCode2'));
  if EssentialsManager.CustomNamesManager.HasCustomName('TDonation', 'AnalysisCode3', {o}customName) then
    SummaryReportSelector.LookupValues.AddPair('ANALYSIS_CODE_3', customName);

  SummaryReportSelector.LookupValues.AddPair(DONATION_KIND, GetCustomName('DonationKind'));
  SummaryReportSelector.LookupValues.AddPair('IMPORT_ID', 'Batch');
  SummaryReportSelector.LookupValues.AddPair('BANKING_REFERENCE', GetCustomName('BankingReference'));
  SummaryReportSelector.LookupValues.AddPair('PAYMENT_METHOD', GetCustomName('PaymentMethod'));
  SummaryReportSelector.LookupValues.AddPair(CLAIM_ID, 'Claim');

  SummaryReportSelector.ItemIndex := 0;
  FLastSelected := SummaryReportSelector.Value;
end;

procedure TSummaryReportSelector.AllCheckboxClick(Sender: TObject);
begin
  inherited;
  ToDatePicker.Enabled := not (Sender as TCheckBox).Checked;
  FromDatePicker.Enabled := ToDatePicker.Enabled;
end;

procedure TSummaryReportSelector.DownloadSummaryReport;
begin
  FIsRunning := True;
  OKButton.Enabled := False;
  try
    Await(TSummaryReportUtils.SummaryReport(SummaryReportSelector.Value, FromDate, ToDate, DateFieldSelector.Value));
  finally
    FIsRunning := False;
    OKButton.Enabled := True;
  end;
end;

procedure TSummaryReportSelector.FromDatePickerChange(Sender: TObject);
begin
  inherited;
  if FromDatePicker.Date > ToDatePicker.Date then
    ToDatePicker.Date := FromDatePicker.Date;
end;

function TSummaryReportSelector.GetFromDate: TDate;
begin
  if AllCheckbox.Visible and AllCheckbox.Checked then
    Exit(0);

  Result := FromDatePicker.Date;
end;

function TSummaryReportSelector.GetToDate: TDate;
begin
  if AllCheckbox.Visible and AllCheckbox.Checked then
    Exit(0);

  Result := ToDatePicker.Date;
end;

procedure TSummaryReportSelector.OKButtonClick(Sender: TObject);
begin
  inherited;
  DownloadSummaryReport;
end;

procedure TSummaryReportSelector.SetAllModifier(const Value: string);
begin
  AllCheckboxLabel.Caption := 'All ' + Value;
end;

procedure TSummaryReportSelector.ShowHideAllSelector(ShouldShow: Boolean);
begin
  AllCheckbox.Visible := ShouldShow;
end;

procedure TSummaryReportSelector.SummaryReportSelectorChange(Sender: TObject);
begin
  inherited;
  //We want to change values in date selector ONLY if switched from or to claims
  if
    ((FLastSelected = CLAIM_ID) and (SummaryReportSelector.Value <> FLastSelected))
    or
    ((FLastSelected <> CLAIM_ID) and (SummaryReportSelector.Value = CLAIM_ID))
  then
    AddDateFields;

  FLastSelected := SummaryReportSelector.Value;
end;

procedure TSummaryReportSelector.ToDatePickerChange(Sender: TObject);
begin
  inherited;
  if ToDatePicker.Date < FromDatePicker.Date then
    FromDatePicker.Date := ToDatePicker.Date;
end;

procedure TSummaryReportSelector.WebformCreate(Sender: TObject);
begin
  inherited;
  FIsRunning := False;
  AddReportTypes;
  AddDateFields;
  FromDatePicker.Date := IncMonth(Yesterday, -1);
  ToDatePicker.Date := Yesterday;
  SummaryReportSelector.SetFocus;
end;

procedure TSummaryReportSelector.LoadDFMValues;
begin
  inherited LoadDFMValues;

  AllCheckboxLabel := TLabel.Create('summaryreport.all.checkbox.label');
  FromDatePicker := TDateTimePicker.Create('summaryreport.fromdate.picker');
  ToDatePicker := TDateTimePicker.Create('summaryreport.todate.picker');
  OKButton := TButton.Create('summaryreport.ok.button');
  CancelButton := TButton.Create('summaryreport.cancel.button');
  AllCheckbox := TCheckBox.Create('summaryreport.all.checkbox');
  SummaryReportSelector := TLookupComboBox.Create('summaryreport.selector');
  DateFieldSelector := TLookupComboBox.Create('summaryreport.datefield.selector');

  AllCheckboxLabel.BeforeLoadDFMValues;
  FromDatePicker.BeforeLoadDFMValues;
  ToDatePicker.BeforeLoadDFMValues;
  OKButton.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  AllCheckbox.BeforeLoadDFMValues;
  SummaryReportSelector.BeforeLoadDFMValues;
  DateFieldSelector.BeforeLoadDFMValues;
  try
    Width := 438;
    Height := 197;
    Caption := 'SummaryReportSelector';
    ElementClassName := 'PopUpForm';
    SetEvent(Self, 'OnCreate', 'WebformCreate');
    AllCheckboxLabel.SetParentComponent(Self);
    AllCheckboxLabel.Name := 'AllCheckboxLabel';
    AllCheckboxLabel.Left := 136;
    AllCheckboxLabel.Top := 104;
    AllCheckboxLabel.Width := 3;
    AllCheckboxLabel.Height := 15;
    AllCheckboxLabel.HeightPercent := 100.000000000000000000;
    AllCheckboxLabel.WidthPercent := 100.000000000000000000;
    FromDatePicker.SetParentComponent(Self);
    FromDatePicker.Name := 'FromDatePicker';
    FromDatePicker.Left := 16;
    FromDatePicker.Top := 24;
    FromDatePicker.Width := 170;
    FromDatePicker.Height := 22;
    FromDatePicker.ElementClassName := 'form-control';
    FromDatePicker.BorderStyle := bsNone;
    FromDatePicker.Color := clWhite;
    FromDatePicker.Date := 46008.470951435190000000;
    FromDatePicker.Role := '';
    FromDatePicker.Text := '';
    SetEvent(FromDatePicker, Self, 'OnChange', 'FromDatePickerChange');
    ToDatePicker.SetParentComponent(Self);
    ToDatePicker.Name := 'ToDatePicker';
    ToDatePicker.Left := 208;
    ToDatePicker.Top := 24;
    ToDatePicker.Width := 170;
    ToDatePicker.Height := 22;
    ToDatePicker.ElementClassName := 'form-control';
    ToDatePicker.BorderStyle := bsNone;
    ToDatePicker.ChildOrder := 1;
    ToDatePicker.Color := clWhite;
    ToDatePicker.Date := 46008.470951435190000000;
    ToDatePicker.Role := '';
    ToDatePicker.Text := '';
    SetEvent(ToDatePicker, Self, 'OnChange', 'ToDatePickerChange');
    OKButton.SetParentComponent(Self);
    OKButton.Name := 'OKButton';
    OKButton.Left := 220;
    OKButton.Top := 148;
    OKButton.Width := 96;
    OKButton.Height := 25;
    OKButton.Caption := 'Run';
    OKButton.ChildOrder := 2;
    OKButton.ElementClassName := 'btn btn-primary';
    OKButton.HeightPercent := 100.000000000000000000;
    OKButton.WidthPercent := 100.000000000000000000;
    SetEvent(OKButton, Self, 'OnClick', 'OKButtonClick');
    CancelButton.SetParentComponent(Self);
    CancelButton.Name := 'CancelButton';
    CancelButton.Left := 334;
    CancelButton.Top := 148;
    CancelButton.Width := 96;
    CancelButton.Height := 25;
    CancelButton.Caption := 'Cancel';
    CancelButton.ChildOrder := 2;
    CancelButton.ElementClassName := 'btn btn-light';
    CancelButton.HeightPercent := 100.000000000000000000;
    CancelButton.ModalResult := 2;
    CancelButton.WidthPercent := 100.000000000000000000;
    AllCheckbox.SetParentComponent(Self);
    AllCheckbox.Name := 'AllCheckbox';
    AllCheckbox.Left := 16;
    AllCheckbox.Top := 74;
    AllCheckbox.Width := 113;
    AllCheckbox.Height := 22;
    AllCheckbox.Caption := 'All';
    AllCheckbox.ChildOrder := 4;
    AllCheckbox.HeightPercent := 100.000000000000000000;
    AllCheckbox.WidthPercent := 100.000000000000000000;
    SetEvent(AllCheckbox, Self, 'OnClick', 'AllCheckboxClick');
    SummaryReportSelector.SetParentComponent(Self);
    SummaryReportSelector.Name := 'SummaryReportSelector';
    SummaryReportSelector.Left := 200;
    SummaryReportSelector.Top := 64;
    SummaryReportSelector.Width := 145;
    SummaryReportSelector.Height := 22;
    SummaryReportSelector.ElementClassName := 'form-select';
    SummaryReportSelector.HeightPercent := 100.000000000000000000;
    SummaryReportSelector.WidthPercent := 100.000000000000000000;
    SetEvent(SummaryReportSelector, Self, 'OnChange', 'SummaryReportSelectorChange');
    SummaryReportSelector.ItemIndex := -1;
    DateFieldSelector.SetParentComponent(Self);
    DateFieldSelector.Name := 'DateFieldSelector';
    DateFieldSelector.Left := 200;
    DateFieldSelector.Top := 101;
    DateFieldSelector.Width := 145;
    DateFieldSelector.Height := 22;
    DateFieldSelector.ElementClassName := 'form-select';
    DateFieldSelector.HeightPercent := 100.000000000000000000;
    DateFieldSelector.WidthPercent := 100.000000000000000000;
    DateFieldSelector.ItemIndex := -1;
  finally
    AllCheckboxLabel.AfterLoadDFMValues;
    FromDatePicker.AfterLoadDFMValues;
    ToDatePicker.AfterLoadDFMValues;
    OKButton.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
    AllCheckbox.AfterLoadDFMValues;
    SummaryReportSelector.AfterLoadDFMValues;
    DateFieldSelector.AfterLoadDFMValues;
  end;
end;

end.
